import React from 'react';

export default function PricingCard({ pkg }) {
  const attrs = pkg.attributes || pkg;
  const features = attrs.features || [];

  const formatPrice = (price) => {
    return new Intl.NumberFormat('da-DK').format(price);
  };

  return (
    <div className={`pricing-card ${attrs.isPopular ? 'pricing-card--popular' : ''}`}>
      {attrs.isPopular && <div className="pricing-card__badge">Mest populær</div>}
      <h3 className="pricing-card__name">{attrs.name}</h3>
      <div className="pricing-card__price">
        {formatPrice(attrs.monthlyPrice)} <span>kr./md.</span>
      </div>
      {attrs.onboardingPrice && (
        <p className="pricing-card__onboarding">
          Onboarding: {formatPrice(attrs.onboardingPrice)} kr.
        </p>
      )}
      <ul className="pricing-card__features">
        {features.map((feature, i) => (
          <li key={i}>{feature}</li>
        ))}
      </ul>
      <a href={attrs.ctaUrl || '/kontakt'} className="btn btn--primary" style={{ width: '100%', textAlign: 'center' }}>
        {attrs.ctaText || 'Kom i gang'}
      </a>
    </div>
  );
}
